<template>
<div class="press_release"
     v-if="item">
  <sliceheadline :item="item" />
  <slicetext :text="text" />
  <component v-for="slice in body"
             :key="slice.id"
             :is="'slice'+slice.slice_type"
             :item="item"
             :slice="slice">
  </component>
</div>
</template>

<script>
export default {
  name: "PressRelease",
  props: [ 'uid', 'title', ],
  created() {
    this.getContent()
  },
  data() {
    return {
      item: null
    }
  },
  metaInfo() {
    return {
      title: this.item ? this.$prismic.asText(this.item.data.title) : "Loading...",
      link: {rel: 'canonical', href: 'https://hungerfreeamerica.org/'+ this.$route.fullPath}
    };
  },
  computed: {
    text() {
      return this.item.data.content
        .concat( {
          type: 'heading6',
          text: '###'
        } )
    },
    body(){
      return this.item.data.body
    }
  },
  methods: {
    getContent( lang ) {
      this.$prismic.client.getByUID( 'press_release', this.uid, {
        lang: lang || this.language,
        fetchLinks: [ 'bio.portrait', 'bio.title', 'bio.job_title', 'bio.qualifications', 'bio.email', 'bio.telephone' ]
      } ).then( response => {
        if ( response ) {
          this.item = response
        }
      } )
    },
  }
};
</script>
<style scoped lang="scss">
.press_release {
    display: grid;
    grid-gap: 2rem;

    /deep/ .slice-text {
        // max-width: 800px;
        .other * {
            font-size: 1.5rem;
            text-align: center;
        }

    }
}
</style>
